import { FC, useEffect, useRef, useState } from 'react';

import {
  App,
  Button,
  Checkbox,
  Col,
  Form,
  FormInstance,
  Input,
  Radio,
  Row
} from 'antd';

import ReCaptcha, { ReCaptchaRef } from 'components/ReCaptcha/ReCaptcha';

import { SECTION_ROW_GUTTER } from 'constants/commons';

import { ReactComponent as ArrowRight } from 'assets/icons/arrowRight.svg';

import styles from '../AuthJobseeker.module.scss';

interface CheckEmailProps {
  isLoading: boolean;
  handleCheckEmail: () => Promise<void>;
}

const CheckEmail: FC<CheckEmailProps> = ({ isLoading, handleCheckEmail }) => {
  const recaptchaRef = useRef<ReCaptchaRef>(null);

  const onCaptchaChange = async (value: string | null): Promise<void> => {
    if (value) {
      await handleCheckEmail();
    }
  };

  const handleExpired = (): void => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  const handleError = (): void => {
    console.error('reCAPTCHA error occurred');
  };

  const handleSubmit = async () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.execute();
    }
  };

  return (
    <>
      <Row gutter={SECTION_ROW_GUTTER} className={styles.row}>
        <Col span={24}>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                type: 'email',
                required: true,
                message: 'email is not a valid'
              }
            ]}
          >
            <Input placeholder="Enter Your Email" />
          </Form.Item>
        </Col>
      </Row>

      <div className={styles.submitContainer}>
        <Button
          className={styles.submitButton}
          type="primary"
          icon={<ArrowRight />}
          iconPosition="end"
          onClick={handleSubmit}
          loading={isLoading}
        >
          Submit
        </Button>
      </div>
      <ReCaptcha
        ref={recaptchaRef}
        onChange={onCaptchaChange}
        onError={handleError}
        onExpired={handleExpired}
      />
    </>
  );
};

export default CheckEmail;
